import React, { createContext, useContext, useState, useCallback } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useDispatch } from "react-redux";
import { updateNotifications } from "store/notificationReducer";
import {
  getUTCTimeStamp,
} from "utils/datepicker-util/converters/date";
import { generateUUID } from "store/hiredrateConst";

// Create context
const NotificationContext = createContext();

// Custom hook for consuming the context
export const useNotification = () => useContext(NotificationContext);

const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);
  const dispatch = useDispatch();

  // Show notification and dispatch to Redux
  const showNotification = useCallback((type, message, color = "default", source = "App") => {
    if (!["success", "error", "warning", "info"].includes(type)) {
      console.error("Invalid notification type");
      return;
    }

    const notificationObj = {
      id: generateUUID(),
      type,
      message: ` ${message} `,
      color,
      timeStamp: new Date().toISOString(), 
      utcTimeStamp: getUTCTimeStamp() || new Date().getTime(),
      source, // e.g., "Dashboard", "Job Position", etc.
    };

    // Show in Snackbar
    setNotification(notificationObj);

    // Dispatch to Redux
    dispatch(updateNotifications(notificationObj));
  }, [dispatch]);

  const handleClose = () => {
    setNotification(null);
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      {notification && (
        <Snackbar
          open={!!notification}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleClose}
            severity={notification.type}
            variant="filled"
          >
            {notification.message}
          </Alert>
        </Snackbar>
      )}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
